import apiFetch from '@wordpress/api-fetch';

export async function postSecurityEvent({ event, context = {} } = {}) {
  return apiFetch({
    path: '/digivibe-savora/v1/savora/security/event',
    method: 'POST',
    data: {
      event,
      context,
      timestamp: Date.now(),
    },
  });
}
